<template>
  <div class="riclothes-card" :class="{dark: this.$root.config.isDarkTheme}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ri-clothes-card"
}
</script>

<style lang="scss" scoped>
.riclothes-card {
  --card-background-color: #ffffff;
  --card-shadow-color: rgba(0,0,0,0.14);

  padding: 8px;
  border-radius: 4px;
  width: 65%;
  margin: 0 auto;
  background-color: var(--card-background-color);
  transition: 0.5s;
  box-shadow: 0 2px 8px var(--card-shadow-color);
}

.dark {
  --card-background-color: #2a2a2a;
  --card-shadow-color: rgba(0,0,0,0.20);
}

@media screen and (max-width: 896px) {
  .riclothes-card {
    width: 90%;
  }
}
</style>